var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"assigned-shift",on:{"click":_setup.selectClaim}},[_c('div',{class:['radio-box', _setup.isSelected ? 'selected' : '']},[_c(_setup.CheckCircleFilled,{attrs:{"color":_setup.isSelected ? _setup.PaletteColors['brand-primary'] : _setup.PaletteColors['base-white']}})],1),(_setup.props.employee)?_c(_setup.EmployeeCardSmall,{attrs:{"claim":_setup.formatClaimForProfile({
        roles: _setup.props.employee.roles, // employee roles
        function: _setup.props.employee.function, // shift function
        role: _setup.props.employee.role, // shift role
        raise_shifts_worked: _setup.props.employee.raise_shifts_worked,
        raise_rating_avg: _setup.props.employee.raise_rating_avg,
        internal_rating_for_worker: _setup.props.employee.internal_rating_for_worker,
        worker_id: _setup.props.employee.worker_id,
        worker_name: _setup.props.employee.worker_name,
        distance_km: _setup.props.employee.distance_km,
      })}}):_vm._e(),_c(_setup.ChildShiftCard,{attrs:{"shift":_setup.props.shift}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }